import { render, staticRenderFns } from "./latestList.vue?vue&type=template&id=60403fd8&scoped=true&"
import script from "./latestList.vue?vue&type=script&lang=js&"
export * from "./latestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60403fd8",
  null
  
)

/* custom blocks */
import block0 from "./latestList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports